// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"494":"2260e473","573":"b4ecb796","707":"38e6b978"}[chunkId] + ".chunk.js";
};